interface DrawPizzaOpts {
    numerator?: number;
    denominator?: number;
    size?: number;
    radius?: number;
    highlightColor?: string;
    baseColor?: string;
}

export function drawPizza(canvas: HTMLCanvasElement, opts?: DrawPizzaOpts): void {
    if (!(canvas instanceof HTMLCanvasElement)) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const {
        numerator = 0,
        denominator = 1,
        size = 400,
        radius = 150,
        highlightColor = '#f4a261',
        baseColor = '#ffffff',
    } = opts ?? {};

    const dpr = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    canvas.width = Math.round(size * dpr);
    canvas.height = Math.round(size * dpr);
    canvas.style.width = `${size}px`;
    canvas.style.height = `${size}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    ctx.clearRect(0, 0, size, size);

    const cx = size / 2;
    const cy = size / 2;

    const clampedDen = Math.max(1, Math.floor(denominator));
    const clampedNum = Math.max(0, Math.min(Math.floor(numerator), clampedDen));
    const sliceAngle = (Math.PI * 2) / clampedDen;

    for (let i = 0; i < clampedDen; i++) {
        const start = -Math.PI / 2 + i * sliceAngle;
        const end = start + sliceAngle;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, radius, start, end);
        ctx.closePath();
        ctx.fillStyle = i < clampedNum ? highlightColor : baseColor;
        ctx.fill();
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#000000';
        ctx.stroke();
    }

    ctx.beginPath();
    ctx.arc(cx, cy, radius, 0, Math.PI * 2);
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#000000';
    ctx.stroke();
}

export const pizza = {
    key: 'pizza',
    name: 'Pizza Slice Visualiser',
    draw: drawPizza,
    meta: {
        title: 'Pizza Slice Visualiser',
        description: 'Interactive pizza/circle diagram that visualises fractions.',
        icon: '¼',
        href: '/methods/pizza',
    },
};

export default drawPizza;
